import request from '@/utils/request'

const registeredApi = {
    //获取科室
    getDept: "/patient-BaaS-proxy/clinic/getDept",
    //获取患者信息
    getPatientInfo: "/patient-BaaS-proxy/clinic/getPatientInfo",
    //获取排班信息
    getClinicForRegist: "/patient-BaaS-proxy/clinic/getClinicForRegist",
    //获取号源信息
    getClinicForRegistDetail: "/patient-BaaS-proxy/clinic/getClinicForRegistDetail",
    //预约挂号
    order: "/patient-BaaS-proxy/clinic/insertClinic",// patient-BaaS-proxy/clinic/order_error _error:模拟返回预约失败
}

/**
 * 获取患者信息
 * @returns 
 */
export function getPatientInfo(data){
    return request({
        url: registeredApi.getPatientInfo,
        method: 'post',
        data
    });
}

/**
 * 获取科室信息
 * @param {*} data 
 * @returns 
 */
export function getDept(data){
    return request({
        url: registeredApi.getDept,
        method: 'post',
        data
    });
}

/**
 * 获取到排班信息
 * @param {*} data 
 * @returns 
 */
export function getClinicForRegist(data){
    return request({
        url: registeredApi.getClinicForRegist,
        method: 'post',
        data
    });
}

/**
 * 号源查询
 * @param {*} data 
 */
export function getClinicForRegistDetail(data){
    return request({
        url: registeredApi.getClinicForRegistDetail,
        method: 'post',
        data
    });
}

/**
 * 挂号预约
 * @param {*} data 
 * @returns 
 */
export function order(data){
    return request({
        url: registeredApi.order,
        method: 'post',
        data
    });
}

